const currentUrl = window.location.href;
const baseUrl = currentUrl.split('/#/')[0];

export default baseUrl;